export interface PartnerEcosystemItem {
    logo: string;
    title: string;
    subtext: string;
    description: string;
    thumbnail: string;
    link?: string;
}

export const partnerEcosystemItems: PartnerEcosystemItem[] = [
    {
        logo: "https://assets.gallabox.com/gb-home/partnership/social-sparrow.png",
        thumbnail: "https://assets.gallabox.com/gb-home/partnership/social-sparrow.png",
        title: "Social Sparrow",
        subtext: "India",
        description:
            "Social Sparrow builds WhatsApp sales systems that turn leads into paying customers. It connects Meta Ads with WhatsApp automation and AI chatbots that capture, qualify, and follow up with every lead automatically.",
        link: "https://socialsparrow.in",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/partnership/superleap.webp",
        thumbnail: "https://assets.gallabox.com/gb-home/partnership/superleap.webp",
        title: "Superleap AI CRM",
        subtext: "India",
        description:
            "Superleap is an AI-powered enterprise CRM that helps businesses manage leads, marketing automation, and omnichannel communication. It uses built-in AI to analyze customer sentiment, trigger hyper-personalized engagement, and surface sales insights at scale.",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/lp/partner-program-lp/zopreneurs.svg",
        thumbnail: "https://assets.gallabox.com/gb-home/partnership/zopreneurs.png",
        title: "Zopreneurs",
        subtext: "Middle East, Africa",
        description:
            "Zopreneurs is an authorised Zoho partner assisting Middle Eastern and South African businesses to grow effortlessly with custom CRM and business automation solutions. They offer effective online strategies to streamline consumer services, operations, and more.",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/lp/partner-program-lp/bluetick-logo.svg",
        thumbnail: "https://assets.gallabox.com/gb-home/partner-program/bluetick-logo.png",
        title: "Bluetick Technologies",
        subtext: "Africa",
        description:
            "Bluetick, a WhatsApp solutions agency that recognized WhatsApp's potential to replace outdated email communications. Bluetick delivers turnkey WhatsApp automation across diverse sectors and use cases, helping businesses automate customer engagement at every stage of the journey.",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/lp/partner-program-lp/bricks.svg",
        thumbnail: "https://assets.gallabox.com/gb-home/partner-program/bricks.png",
        title: "Bricks",
        subtext: "Kuwait",
        description:
            "Founded in 2018, Bricks is a creative studio and digital marketing agency transforming Kuwait's marketing and production landscape. They specialize in web design, video production, branding, and full-service digital marketing to help businesses stand out.",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/lp/partner-program-lp/gcs-technology.svg",
        thumbnail: "https://assets.gallabox.com/gb-home/partnership/gcs-technology.png",
        title: "GCS Technology LLC",
        subtext: "Middle East",
        description:
            "GCS Technology LLC is an esteemed provider of comprehensive business process management solutions for accounting, payroll, CRM and ERP, asset management, sales and marketing, database management and more.",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/lp/partner-program-lp/poixel.svg",
        thumbnail: "https://assets.gallabox.com/gb-home/partner-program/poixel.png",
        title: "Poixel",
        subtext: "Kuwait",
        description:
            "Poixel empowers businesses with creative visual designs that attract market demand. They combine compelling visuals with data-driven marketing standards to build successful portfolios based on case studies and measurable results.",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/lp/partner-program-lp/bluetickpro.svg",
        thumbnail: "https://assets.gallabox.com/gb-home/partner-program/bluetickpro.png",
        title: "Blue Tick Pro",
        subtext: "Middle East",
        description:
            "Bluetick.pro specializes in implementing Brand Indicators for Message Identification (BIMI) and Verified Mark Certificates (VMC). They help businesses achieve verified badge status on email and WhatsApp communications, building trust and improving deliverability.",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/lp/partner-program-lp/3tech-partner.svg",
        thumbnail: "https://assets.gallabox.com/gb-home/partnership/3tech-partner.jpg",
        title: "3Tech",
        subtext: "Jeddah, Saudi Arabia",
        description:
            "Founded to bridge creativity and technology, 3Tech delivers more than just digital services—they craft inspiring, results-driven experiences. With over 7 years in business, the company has successfully completed 150+ projects and earned an impressive 99% client satisfaction rate.",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/lp/partner-program-lp/agn.svg",
        thumbnail: "https://assets.gallabox.com/gb-home/partner-program/agn.png",
        title: "AGN IT SERVICES",
        subtext: "Middle East",
        description:
            "AGN IT Services has been providing IT solutions since 2003. As a leading partner of Microsoft, AWS, Zoho, and Odoo, they deliver end-to-end cloud technology, IT solutions, and and support services to businesses across industries.",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/lp/partner-program-lp/goyzer.svg",
        thumbnail: "https://assets.gallabox.com/gb-home/partner-program/goyzer.png",
        title: "Goyzer",
        subtext: "Middle East",
        description:
            "Founded in Canada (2015) with a Dubai office, Goyzer builds automation tools for real estate developers, property managers, and brokers. They focus on business transformation through technology, delivering operational efficiency across the real estate value chain.",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/lp/partner-program-lp/absoft.svg",
        thumbnail: "https://assets.gallabox.com/gb-home/partner-program/absoft.png",
        title: "Absoft IT Solutions Pvt Ltd",
        subtext: "Middle East",
        description:
            "Absoft is a 360° IT services and technology solutions company helping businesses streamline processes and accelerate growth. They provide digital transformation services across platforms including Zoho, Salesforce, HubSpot, and more.",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/lp/partner-program-lp/yaticorp.svg",
        thumbnail: "https://assets.gallabox.com/gb-home/partner-program/yaticorp.png",
        title: "YATICORP INDIA PRIVATE LIMITED",
        subtext: "India",
        description:
            "A consultancy that offers business strategy services to optimize operations and drive growth. They specialize in digitalization and automation solutions, WhatsApp automation, tech infrastructure support, and AI education initiatives including unique AI learning tools for business empowerment.",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/lp/partner-program-lp/softel.svg",
        thumbnail: "https://assets.gallabox.com/gb-home/partner-program/softel.png",
        title: "Softel Solutions",
        subtext: "India",
        description:
            "Softel Solutions is a premier IT solutions provider with a strong presence in Singapore and India. They specialize in innovative, scalable, and high-performance technology services designed to meet the diverse and evolving needs of clients across industries.",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/lp/partner-program-lp/blik.svg",
        thumbnail: "https://assets.gallabox.com/gb-home/partner-program/blik.png",
        title: "Blik",
        subtext: "India",
        description:
            "Blik is a performance marketing agency that focuses on data-driven decisions for branding, digital marketing, business development, and digital growth. They help businesses optimize marketing performance through analytics and strategic execution.",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/lp/partner-program-lp/linz-technologies.svg",
        thumbnail: "https://assets.gallabox.com/gb-home/partnership/linz-technologies.png",
        title: "Linz Technologies",
        subtext: "India and Middle East",
        description:
            "Alchemist Advanced Technologies provides tech solutions that help growing businesses handle operations, functions, and staff. It assists businesses with lead generation, conversion, customer management, feedback, sales integration, and customer support.",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/lp/partner-program-lp/cleanomatics.svg",
        thumbnail: "https://assets.gallabox.com/gb-home/partner-program/cleanomatics.png",
        title: "Cleanomatics Tech Solutions",
        subtext: "India",
        description:
            "Cleanomatics Tech Solutions is the strategic business unit of Cleanomatics, a Silicon Valley startup incubated at Berkeley SkyDeck. After becoming Zoho Authorized Partners and perfecting their own tech stack, they created this division to enable SMEs with technology solutions by streamlining their operations.",
    },
    {
        logo: "https://assets.gallabox.com/gb-home/lp/partner-program-lp/corefactors.svg",
        thumbnail: "https://assets.gallabox.com/gb-home/partnership/corefactors.png",
        title: "Corefactors",
        subtext: "India, USA, Africa",
        description:
            "Corefactors was founded in 2013 to help businesses sell and scale faster by automating their sales process, enabling RevOps and increasing revenue. They work with over 350+ companies and have over 12,000 users in India and the US.",
    },
];

export const partnerLogoSlides = partnerEcosystemItems.map((item) => ({
    thumbnailUrl: item.thumbnail,
    logoUrl: item.logo,
    alt: item.title,
    width: 120,
    height: 80,
}));
